var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_1581)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.75C16.25 9.74456 16.6451 10.6984 17.3483 11.4017C18.0516 12.1049 19.0054 12.5 20 12.5C20.9946 12.5 21.9484 12.1049 22.6516 11.4017C23.3549 10.6984 23.75 9.74456 23.75 8.75H31.25C31.5815 8.75 31.8995 8.8817 32.1339 9.11612C32.3683 9.35054 32.5 9.66848 32.5 10V18.75C32.5 19.0815 32.3683 19.3995 32.1339 19.6339C31.8995 19.8683 31.5815 20 31.25 20H28.7487L28.75 30C28.75 30.3315 28.6183 30.6495 28.3839 30.8839C28.1495 31.1183 27.8315 31.25 27.5 31.25H12.5C12.1685 31.25 11.8505 31.1183 11.6161 30.8839C11.3817 30.6495 11.25 30.3315 11.25 30L11.2487 19.9987L8.75 20C8.41848 20 8.10054 19.8683 7.86612 19.6339C7.6317 19.3995 7.5 19.0815 7.5 18.75V10C7.5 9.66848 7.6317 9.35054 7.86612 9.11612C8.10054 8.8817 8.41848 8.75 8.75 8.75H16.25ZM30 11.2488H25.7287L25.7075 11.3C25.2335 12.3598 24.4737 13.2667 23.5133 13.9191C22.553 14.5715 21.4299 14.9436 20.27 14.9937L20 15C18.793 15.0001 17.6118 14.6508 16.599 13.9942C15.5862 13.3376 14.7851 12.4019 14.2925 11.3L14.27 11.25H10V17.5L13.7487 17.4987V28.75H26.25L26.2487 17.5L30 17.4987V11.2488Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothing);
export default __webpack_public_path__ + "static/media/Clothing.25866b34.svg";
export { ForwardRef as ReactComponent };